<script>
export default {
  name: "aboutUsImage"
};
</script>

<template>
  <el-row class="container-image-wrapper">
    <el-col :span="24">
      <div class="container-image">
        <img
          src="../../assets/about-us.jpg"
          style="object-fit: contain;width: 100%; height: 277px"
        />
      </div>
    </el-col>
  </el-row>
</template>

<style scoped>
.container-image-wrapper {
  padding: 0;
  background-color: #ffffff;
}
.container-image {
  position: relative;
  text-align: center;
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/about/aboutUsImage.vue